import Form from './form'
import List from './list'

export default {
  list: List,
  edit: Form,
  create: Form,
}
